import { ShareDeeplinkType } from "common/types";
import { sprintf } from "sprintf-js";

export const ToUpperCase = String.prototype.toUpperCase;
export const ToLowerCase = String.prototype.toLowerCase;

/**
 * Get first character of each word in a string
 * @param str String to process
 * @returns
 */
export function getFirstLetters(str: string, formatFunc: () => string = ToUpperCase) {
  if (!str || str.length === 0) return 'NA';

  str = str.trim();

  const value = getMax2Characters(str.split(' ').map(i => i.charAt(0)).join());

  formatFunc = formatFunc ?? String.prototype.toUpperCase;

  return formatFunc.call(value);
}

function getMax2Characters(str: string) {
  if (str.length >= 2) {
    return str.substring(0, 1);
  } else {
    return str[0];
  }
}

export function generateUniversalUrl(id: string, linkType: ShareDeeplinkType) {

  const playstore = 'https://play.google.com/store/apps/details?id=com.app.emoshare';
  const appstore = 'https://apps.apple.com/vn/app/emoshare/id1577723948';

  const DEEPLINK_PREFIX = process.env.REACT_APP_DEEPLINK_PREFIX || 'emoshare';

  let iOSDeepLink = sprintf('%s://emoshare.com/event/%s', DEEPLINK_PREFIX, id);
  let androidDeepLink = sprintf('emoshare://emoshare.com/event/%s', id);

  if (linkType === ShareDeeplinkType.FanClub) {
    iOSDeepLink = sprintf('%s://emoshare.com/club/%s', DEEPLINK_PREFIX, id);
    androidDeepLink = sprintf('emoshare://emoshare.com/club/%s', id);
  }

  return {
    playstore,
    appstore,
    androidDeepLink,
    iOSDeepLink,
  };
}

/**
 * Truncate text string
 * @param str Text to truncate
 * @param n Max length
 * @param useWordBoundary
 */
 export function truncate(str: string, n: number, useWordBoundary: boolean = false){
  if (!str) return '';
  if (str.length <= n) return str;
  const subString = str.substring(0, n-1); // the original check
  return (useWordBoundary ? subString.substring(0, subString.lastIndexOf(' ')) : subString) + '...';
}